import * as yup from 'yup';

import { TE_PAGE_TOPIC_CHAR_LIMIT } from '@lessonPlanner/constants';

const TopicExplorerSchema = yup.object().shape({
  topic: yup
    .string()
    .when('explorerType', {
      is: 'Explorer',
      then: (schema) => schema.required('Please enter a topic')
        .test(
          'len',
          'You have reached the character limit',
          (val) => val && val.length <= TE_PAGE_TOPIC_CHAR_LIMIT,
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
  explorerType: yup
    .string()
    .required('Please select an explorer type'),
  subject: yup
    .string()
    .when('explorerType', {
      is: 'Breakdown',
      then: (schema) => schema.required('Subject is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  gradeLevel: yup
    .string()
    .when('explorerType', {
      is: 'Breakdown',
      then: (schema) => schema.required('Grade Level is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  itemToUnpack: yup
    .string()
    .when('explorerType', {
      is: 'Breakdown',
      then: (schema) => schema.required('Please enter a topic to break down'),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export default TopicExplorerSchema;
